module.exports = __webpack_public_path__ + "img/green_067.fa51afa4.png";